import React, { FormEvent, useState } from "react";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import { Button } from "../../../components/common";
import { subscribeToBlogNewsletter } from "../../../services/blog.services";

const NewsletterSignup = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    if (!email || isSubmitting) return;

    setIsSubmitting(true);
    setMessage("");

    const response = await subscribeToBlogNewsletter(email.trim());
    setIsSuccess(response.success);
    setMessage(response.message);
    if (response.success) setEmail("");
    setIsSubmitting(false);
  };

  return (
    <section className="blog-newsletter" aria-labelledby="newsletter-title">
      <span className="blog-newsletter__icon"><MailOutlineIcon /></span>
      <div>
        <h2 id="newsletter-title">Your weekly career edge</h2>
        <p>Practical career advice, job opportunities and employHER updates — straight to your inbox.</p>
      </div>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          value={email}
          onChange={(event) => {
            setEmail(event.target.value);
            setMessage("");
          }}
          placeholder="Enter your email address"
          aria-label="Email address"
          autoComplete="email"
          name="email"
          required
        />
        <Button type="submit" loading={isSubmitting} disabled={isSubmitting}>
          {isSubmitting ? "Subscribing..." : "Subscribe"}
        </Button>
        <small aria-live="polite" className={message ? (isSuccess ? "is-success" : "is-error") : ""}>
          {message || "No spam. Unsubscribe anytime."}
        </small>
      </form>
    </section>
  );
};

export default NewsletterSignup;
